import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import LegacyReport from "../../components/LegacyReports/LegacyReports";
 
 
const LegacyReportPage: React.FC = () => {
    return (
      <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow  ">
        <Header />
       
        <main >
        <LegacyReport/>
        </main>
        </div>
        <Footer />
       
      </div>
    );
  };
 
  export default LegacyReportPage;